import {
	dashboardDeleteBusinessData,
	DashboardDeleteBusinessDataProps
} from '@/modules/dashboard/dashboardActions';
import { useDispatch } from 'react-redux';

export const useRemoveContactDataMutation = () => {
	const dispatch = useDispatch();

	const mutate = (contactData: DashboardDeleteBusinessDataProps) => {
		dispatch(dashboardDeleteBusinessData(contactData));
	};

	return { mutate };
};
